@if (customization.config|async; as c) {
  <footer>
    @if (layout === 'default') {
      <div class="footer-container mat-subtitle-2">
        <div class="contacts footer-group">
          <p class="h5">{{c.name}}</p>
          <p>{{c.address}}</p>
          <p class="contacts-info">
            @if (c.phone_number) {
              <span>
                <mat-icon svgIcon="pq:phone_call"></mat-icon>
                <span>{{c.phone_number}}</span>
              </span>
            }
            @if (c.phone_number && c.email) {
              <mat-divider [vertical]="true"></mat-divider>
            }
            @if (c.email) {
              <span>
                <mat-icon svgIcon="pq:letter"></mat-icon>
                <span>{{c.email}}</span>
              </span>
            }
          </p>
          <p>
            @if (c.facebook; as link) {
              <a [href]="link">
                <img src="styles/img/social/facebook.svg" alt="Facebook"/>
              </a>
            }
            @if (c.twitter; as link) {
              <a [href]="link">
                <img src="styles/img/social/twitter.svg" alt="Twitter"/>
              </a>
            }
          </p>
        </div>
        <div class="poweredby footer-group">
          <p>{{'Powered by' | translate}}:</p>
          <p>
            <a href="https://payquad.com" target="_blank">
              <img class="logo" src="styles/img/logo-footer.svg" alt="PayQuad Logo">
            </a>
          </p>
        </div>
        <div class="lang-selector">
          <a (click)="locale.setLang('en')" [ngClass]="{'lang-active': locale.currentLang === 'en'}">{{'English' | translate}}</a> |
          <a (click)="locale.setLang('fr')" [ngClass]="{'lang-active': locale.currentLang === 'fr'}">{{'French' | translate}}</a>
        </div>
        <mat-divider class="wide-divider"></mat-divider>
        <div class="footer-group">
          <p>{{'All rights Reserved' | translate}} {{now | date:'yyyy'}}</p>
        </div>
        <div class="term-of-use footer-group">
          <p>
            <a href="/terms-of-service">{{'Terms of Service'|translate}}</a>
            <a href="/privacy-policy">{{'Privacy Policy'|translate}}</a>
            <mat-divider [vertical]="true"></mat-divider>
            <img src="styles/img/geotrust.png">
          </p>
        </div>
      </div>
    }
    @if (layout === 'tiny') {
      <div class="footer-container tiny mat-subtitle-2">
        <div class="footer-group">
          <p>{{'All rights Reserved' | translate}} {{now | date:'yyyy'}}</p>
        </div>
        <div class="term-of-use footer-group">
          <p>
            <a href="/terms-of-service">{{'Terms of Service'|translate}}</a>
            <a href="/privacy-policy">{{'Privacy Policy'|translate}}</a>
            <mat-divider [vertical]="true"></mat-divider>
            <img src="styles/img/geotrust.png" [alt]="'Secured by GeoTrust' | translate">
          </p>
        </div>
      </div>
    }
  </footer>
}
